@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.interrogative {
  @include typography.body-semibold;
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
}

.qualifier {
  text-align: center;
  padding-bottom: 32px;
  margin: 0;
  font-family: typography.$font-mont;
}

.button {
  flex: 1;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.actions {
  display: flex;
  flex-direction: row;
}
